import { format } from 'date-fns';
import React, { /*Dispatch, SetStateAction,*/ useEffect, useState } from 'react';
import { Button, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useLocation } from 'react-router-dom-v5-compat';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { it } from 'date-fns/locale';
import StatusBar from '@components/StatusBar';
import { importStaffPerMonth } from '@lib/api_ts/jobToolApi';

interface ImportJobToolModalProps { }

const ImportJobToolModal: React.FC<ImportJobToolModalProps> = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedMonths, setSelectedMonths] = useState<string[]>([]);
    const location = useLocation();
    const projectId = location.pathname.split('/').at(2);

    const blankStatusBar = {
        status: undefined,
        message: '',
        timeout: undefined,
    };

    const [isLoading, setIsLoading] = useState(false);
    const [statusBar, setStatusBar] = useState(blankStatusBar);
    const resetStatusBar = () => {
        setStatusBar(blankStatusBar);
    };

    const fixErrorMessage = (errorMessage: string) => {
        if (errorMessage.includes("'date'")) {
            return errorMessage.replace("'date'", "La data")
        }
        return errorMessage;
    }
    const handleOnClick = async () => {
        setIsLoading(true);
        setStatusBar({
            status: 'elaborating',
            message: 'Importazione in corso',
            timeout: false,
        });
        try {
            const promises = selectedMonths.map(month =>
                importStaffPerMonth(projectId, month)
            );
            await Promise.all(promises);

            setStatusBar({
                status: 'success',
                message: 'Importazione completata con successo',
                timeout: true,
            });
            setTimeout(() => {
                setIsModalOpen(false);
                resetStatusBar();
                setSelectedMonths([]);
                setIsLoading(false);
            }, 2000);
        } catch (error) {
            console.error('Failed to import:', error);
            setStatusBar({
                status: 'error',
                message: `${error instanceof Error ? fixErrorMessage(error.message) : 'Errore durante l\'importazione dei dati'}`,
                timeout: true,
            });
            setTimeout(() => {
                resetStatusBar();
                setIsLoading(false);
            }, 2000);
        }
    }

    useEffect(() => {
        if (!isModalOpen) return;
        const displayedMonths = document.querySelectorAll('.react-datepicker__month-text') as NodeListOf<HTMLElement>;
        displayedMonths.forEach(month => {
            month.textContent = month.textContent.slice(0, 3)
        });
    }, [isModalOpen]);
    return (
        <>
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id="tooltip-import">
                        Importa i dati aggiornati relativi ai costi del personale per il periodo d'interesse.
                    </Tooltip>
                }
            >
                <Button onClick={() => { setIsModalOpen(true) }} className='mx-3' style={{ width: "auto", marginBottom: "8px" }}>
                    Import dati personale
                </Button>
            </OverlayTrigger>
            <Modal centered show={isModalOpen}
                onHide={() => {
                    setIsModalOpen(false)
                    resetStatusBar();
                    setSelectedMonths([])
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Importa dati</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Label className='mb-1'>Mese di riferimento</Form.Label>
                        <Form.Text className='d-block' style={{
                            borderRadius: "8px",
                            padding: "8px",
                            border: "1px solid #07a2aa",
                            marginBottom: "8px",
                            color: selectedMonths.length > 0 ? "inherit" : "#6c757d",
                        }}>{selectedMonths.length > 0 ?
                            selectedMonths.map(month => format(new Date(month), 'MM/yyyy')).join(', ') :
                            "mm/aaaa"}</Form.Text></Form>
                    <DatePicker
                        selected={null} // 👈 Non serve più selected con selectsMultiple
                        selectedDates={selectedMonths.map(month => new Date(month))} // 👈 Usa selectedDates
                        onChange={(dates) => {
                            if (dates && dates.length > 0) {
                                const monthsArray = dates.map(date => format(date, 'yyyy-MM'));
                                setSelectedMonths(monthsArray);
                            } else {
                                setSelectedMonths([]);
                            }
                        }}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        inline
                        showFullMonthYearPicker
                        selectsMultiple
                        locale={it}

                    />
                </Modal.Body>
                <Modal.Footer className='d-grid justify-content-center'>
                    <Button style={{ marginInline: "auto", marginBottom: "2rem" }} onClick={handleOnClick} disabled={selectedMonths.length === 0 || isLoading} variant="primary">
                        Conferma
                    </Button>

                    {statusBar.status ? (
                        <StatusBar status={statusBar.status} message={statusBar.message} timeout={statusBar.timeout}>
                            <></>
                        </StatusBar>
                    ) : null}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ImportJobToolModal;
